import { combineReducers } from '@reduxjs/toolkit';
// Contact
import slice_AcademicTitle from './slices/academicTitle';
import slice_BusinessForm from './slices/businessForm';
import slice_ContactGroup from './slices/contactGroup';
import slice_Country from './slices/country';
import slice_Gender from './slices/gender';
// LegalClient
import slice_adressType from './slices/adressType';
import slice_RelationshipRole from './slices/relationshipRole';
import slice_RelationshipType from './slices/relationshipType';
import slice_RelationshipTypeHasRole from './slices/relationshipType_has_RelationshipRole';
// Dokumente
import slice_legalRequirementState from './slices/legalRequirementState';
import slice_MIMEType from './slices/mimeType';
// CompanyFormation
import slice_companyFormationOption from './slices/companyFormationOption';
import slice_companyFormationQuestion from './slices/companyFormationQuestion';
// Text Module
import slice_textModule from './slices/textModule';
import slice_textModuleCategory from './slices/textModuleCategory';
// Variable
import slice_dictionaryEntry from './slices/dictionaryEntry';
// Amtsgerichte
import slice_districtCourt from './slices/districtCourt';
import slice_landMarking from './slices/landMarking';

import slice_federalState from './slices/federalState';

const mainReducer = combineReducers({
  // Contact
  genderArray: slice_Gender,
  academicTitleArray: slice_AcademicTitle,
  countryArray: slice_Country,
  businessFormArray: slice_BusinessForm,
  contactGroup: slice_ContactGroup,
  //
  relationshipTypeArray: slice_RelationshipType,
  relationshipRoleArray: slice_RelationshipRole,
  relationshipTypeHasRoleArray: slice_RelationshipTypeHasRole,
  addressTypeArray: slice_adressType,
  // Dokuemten
  mimeTypeArray: slice_MIMEType,
  // Legal Transaction
  legalRequirementStateArray: slice_legalRequirementState,
  // CompanyFormation
  companyFormationQuestionArray: slice_companyFormationQuestion,
  companyFormationOptionArray: slice_companyFormationOption,
  // Text Module
  textModuleCategoryArray: slice_textModuleCategory,
  textModuleArray: slice_textModule,
  // Variable
  dictionaryEntryArray: slice_dictionaryEntry,
  // Amtsgerichte
  districtCourtArray: slice_districtCourt,
  landMarkingArray: slice_landMarking,
  // FederalState
  federalStateArray: slice_federalState,
});
export default mainReducer;
export type State = ReturnType<typeof mainReducer>;
